window.dataLayer = window.dataLayer || []

export default {
    methods: {
        addDataLayer: function (data) {
            window.dataLayer.push(data)
        }
    }
}
